import classNames from 'classnames';

// The shared modal footer for the creation flows: an optional Back (to a chooser), a
// Cancel/Close, and the confirm button. The confirm button is hidden once the run is in
// flight or has failed (only Close remains); Cancel/Back are disabled while running.
export default function CreationActions({
  busy,
  failed,
  canConfirm,
  confirmLabel,
  onClose,
  onConfirm,
  onBack,
}: {
  busy: boolean;
  failed: boolean;
  canConfirm: boolean;
  confirmLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  onBack?: () => void;
}) {
  return (
    <div className="flex justify-between gap-2 mt-2">
      <div>
        {onBack && (
          <button className="btn btn-ghost" onClick={onBack} disabled={busy}>
            Back
          </button>
        )}
      </div>
      <div className="flex gap-2">
        <button className="btn btn-ghost" onClick={onClose} disabled={busy}>
          {failed ? 'Close' : 'Cancel'}
        </button>
        {!busy && !failed && (
          <button
            className={classNames('btn btn-primary', { 'btn-disabled': !canConfirm })}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        )}
      </div>
    </div>
  );
}
